import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';
import { AutoUnsubscribe } from '../../common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { ActionButtonComponent } from '../action-button';
import { ButtonAction } from '../action-button/constants';
import { PageComponent } from '../page';
import {
  DataQualityErrorMessage,
  DataQualityMessagesRawError,
  MessageCheckerFacade,
  MessageCheckerForm,
} from '../../store/state/data-quality/message-checker/models/message-checker.model';
import { filter, map, withLatestFrom } from 'rxjs/operators';

@Component({
  selector: 'ui-message-checker',
  imports: [IntrackFeatureModule, TranslateModule, ActionButtonComponent, PageComponent],
  templateUrl: './message-checker.component.html',
  styleUrls: ['./message-checker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class MessageCheckerComponent implements OnInit {
  @Input() messageCheckerFacade: MessageCheckerFacade;
  buttonAction = ButtonAction;
  subscriptions: Subscription[] = [];
  messageForm: FormGroup<MessageCheckerForm> = this.fb.group<MessageCheckerForm>(new MessageCheckerForm());
  errors$!: Observable<DataQualityMessagesRawError[]>;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.errors$ = this.getErrors$();
    this.initMessageFormSubscription();
  }

  checkMessage(): void {
    if (this.messageForm.invalid) {
      return;
    }
    this.messageCheckerFacade.checkMessage(this.messageForm.value.message.trim());
  }
  // TODO will be implemented in the next story
  // eslint-disable-next-line
  sendMessage(): void {}

  getErrors$(): Observable<DataQualityMessagesRawError[]> {
    return this.messageCheckerFacade.errorMessages$.pipe(
      filter(Boolean),
      map((errorMessage: DataQualityErrorMessage) => {
        const errors = [...(errorMessage.rawMessageParsingErrors ?? [])];
        return (errorMessage.internalValidationErrors ?? []).reduce(
          (acc: DataQualityMessagesRawError[], error: string) => {
            acc.push({ segment: NOT_AVAILABLE, errors: [error] });
            return acc;
          },
          errors,
        );
      }),
    );
  }

  private initMessageFormSubscription(): void {
    this.subscriptions.push(
      this.messageForm.valueChanges
        .pipe(withLatestFrom(this.messageCheckerFacade.loaded$))
        .subscribe(([_, loaded]: [{ message: string }, boolean]) => {
          if (loaded) {
            this.messageCheckerFacade.setInitialState();
          }
        }),
    );
  }
}
